import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface IOnboardingGuideState {
  panelOpen: boolean;
}

const initialState: IOnboardingGuideState = {
  panelOpen: true,
};

const onboardingGuideSlice = createSlice({
  name: 'onboardingGuide',
  initialState,
  reducers: {
    setPanelOpen: (state, action) => {
      state.panelOpen = action.payload;
    },
    resetState: () => ({ ...initialState }),
  },
});

export const { setPanelOpen, resetState } = onboardingGuideSlice.actions;
export const panelOpenSelector = (state: RootState) => state.onboardingGuide.panelOpen;
export default onboardingGuideSlice.reducer;
